// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1HqxT","name":"ConsentHeader_name__8Jzdx","birthday":"ConsentHeader_birthday__2CrUi","skeleton":"ConsentHeader_skeleton__24p87"};